import React, { useState } from "react";
import { observer } from "mobx-react";
import VariantToggle from "Pages/Dashboard/sequences/SequencePage/VariantToggle";
import { pipedriveStore } from "./PipedriveStore";

const ActivityTab = observer(() => {
  const [badgeIndex, setBadgeIndex] = useState("");
  const activityCheckList = [
    {
      key: "emailSent",
      id: "emailSent",
      value: pipedriveStore?.pipedrivePreferences?.syncSentEnabled,
      text: "Email sent"
    },
    {
      key: "emailOpened",
      id: "emailOpened",
      value: pipedriveStore?.pipedrivePreferences?.syncOpenEnabled,
      text: "Email opened"
    },
    {
      key: "emailReplied",
      id: "emailReplied",
      value: pipedriveStore?.pipedrivePreferences?.syncReplyEnabled,
      text: "Email replied"
    },
    {
      key: "emailClicked",
      id: "emailClicked",
      value: pipedriveStore?.pipedrivePreferences?.syncClickEnabled,
      text: "Link clicked in an email"
    },
    {
      key: "phoneCalls",
      id: "phoneCalls",
      value: pipedriveStore?.pipedrivePreferences?.syncPhoneCallEnabled,
      text: "Phone calls"
    },
    {
      key: "liRequestSent",
      id: "liRequestSent",
      value: pipedriveStore?.pipedrivePreferences?.syncLiSendRequest,
      text: "LinkedIn connection request sent"
    },
    {
      key: "liRequestAccepted",
      id: "liRequestAccepted",
      value: pipedriveStore?.pipedrivePreferences?.syncLiAcceptRequest,
      text: "LinkedIn connection request accepted"
    },
    {
      key: "liMessageSent",
      id: "liMessageSent",
      value: pipedriveStore?.pipedrivePreferences?.syncLiMessageSent,
      text: "LinkedIn message sent"
    },
    {
      key: "liMessageReceived",
      id: "liMessageReceived",
      value: pipedriveStore?.pipedrivePreferences?.syncLiReplyReceived,
      text: "LinkedIn reply received"
    },
    {
      key: "customTask",
      id: "customTask",
      value: pipedriveStore?.pipedrivePreferences?.syncCustomTask,
      text: "Custom Task"
    }
  ];

  const mappedConfig = {
    phoneCalls: "syncPhoneCallEnabled",
    emailClicked: "syncClickEnabled",
    emailReplied: "syncReplyEnabled",
    emailOpened: "syncOpenEnabled",
    emailSent: "syncSentEnabled",
    liRequestSent: "syncLiSendRequest",
    liRequestAccepted: "syncLiAcceptRequest",
    liMessageSent: "syncLiMessageSent",
    liMessageReceived: "syncLiReplyReceived",
    customTask: "syncCustomTask"
  };

  const setCheckedValue = (e, value, id) => {
    pipedriveStore.setPipedrivePreferences({
      ...pipedriveStore?.pipedrivePreferences,
      [mappedConfig?.[id]]: value
    });
  };

  return (
    <div className="activityWrapper">
      <h5 className="headingText">Activity Logging</h5>
      <p className="descText">
        Select the events that you want to log to your Pipedrive CRM
      </p>
      <div className="checkListBox">
        {activityCheckList?.length &&
          activityCheckList?.map((item, index) => {
            const { id = "", text = "", value = "", disabled = false } = item;
            return (
              <div
                key={`${id}-${text}`}
                className="activityCheckListWrapper"
                onMouseEnter={() => setBadgeIndex(index)}
                onMouseLeave={() => setBadgeIndex("")}
              >
                <div
                  className={`variantToggleWrapper ${
                    disabled ? "disabled" : ""
                  }`}
                >
                  <VariantToggle
                    action={setCheckedValue}
                    isChecked={value}
                    id={id}
                  />
                  <span className="toggleText">{text}</span>
                </div>
                {badgeIndex === index && disabled && (
                  <span
                    className="comingSoonBadge"
                    style={{ display: "block" }}
                  >
                    Coming Soon
                  </span>
                )}
              </div>
            );
          })}
      </div>
    </div>
  );
});

export { ActivityTab };
export default ActivityTab;
